<section class="login-wrap">
  <div class="login-inner">
    <div class="login-left">
      <img src="assets/images/login_img.svg" alt="Login" />
    </div>
    <div class="login-right">
      <div class="login-title">Verify {{isEmailScreen? 'Email ID' :'mobile number'}}</div>
      <div class="login-info">OTP will be sent to this {{isEmailScreen? 'email ID' :'number'}}</div>
      <form [formGroup]="formGroup" class="login-input">
        <span *ngIf="!isEmailScreen" class="code">+91</span>
        <input *ngIf="!isEmailScreen" type="text" class="cus-input"
        pattern="[0-9]*"
        maxlength="10"
        (input)="onPhoneNumberInput($event)"
         formControlName="phoneNumber"/>
        <input *ngIf="isEmailScreen" type="text" class="cus-input email {{showError?'inp-error':''}}" (focus)="showError=false" (blur)="showError=true" (input)="setError()"  type="text" formControlName="email"/>
        <!-- <span *ngIf="isEmailScreen && !showError"  class="cus-input error"> </span> -->
        <span *ngIf="isEmailScreen && showError && formGroup.controls['email'].invalid && formGroup.controls['email'].dirty"  class="cus-input error">{{errorMsg}}</span>
     
      </form>
      <div class="otp-inputs email-otp-field"  *ngIf="isEmailScreen && showOtp" >
        <input  maxlength="1"  type="text" class="cus-input" allowOnlyNumber (input)="handleOtp($event)"/>
        <input  maxlength="1"  type="text" class="cus-input" allowOnlyNumber (input)="handleOtp($event)"/>
        <input  maxlength="1"  type="text" class="cus-input" allowOnlyNumber (input)="handleOtp($event)"/>
        <input  maxlength="1"  type="text" class="cus-input" allowOnlyNumber (input)="handleOtp($event)"/>
        <input  maxlength="1"  type="text" class="cus-input" allowOnlyNumber (input)="handleOtp($event)"/>
        <input  maxlength="1"  type="text" class="cus-input" allowOnlyNumber (input)="handleOtp($event)"/>
      </div>
      <span *ngIf="showOtp && otpErrorMsg"  class="cus-input error">{{otpErrorMsg}}</span>
      <div *ngIf="isEmailScreen && showOtp && emailtimer !== '00' " class="resend-otp">   Resend OTP in <span class="highlight">00:{{emailtimer}}</span></div>
      <div class="resend-link resend-otp" *ngIf="isEmailScreen && showOtp && emailtimer === '00' "  (click)="redirectToOtp()"><span  class="highlight">Resend</span></div>
      
      <div class="login-agree"  *ngIf="!isEmailScreen">
        <div class="cus-check">
          <input class="input-check" type="checkbox" id="login_agree" (click)="tcChecked()"  [(ngModel)]="isChecked"/>
          <label for="login_agree"></label>
        </div>
        <div class="agree-text">I agree to NorthernArc's Terms and Conditions and Privacy Policy. <span class="link" (click)="openTnc()">Read more</span></div>
      </div>
      <button class="btn-primary" *ngIf="!showOtp" (click)="redirectToOtp()"  [disabled]=  "((!isChecked || formGroup.controls['phoneNumber'].invalid) && formGroup.controls['email'].invalid)">Continue</button>
    </div>
  </div>
</section>



<p-dialog header="" [(visible)]="visible" styleClass="cus-dialog-lg cus-dialog" [draggable]="false" [resizable]="false">
  <iframe width="100%" height="400px" [src]="iframeSrc" frameborder="0" allowfullscreen style="overflow: hidden;">
  </iframe>
</p-dialog>
